export default __webpack_public_path__ + "static/media/shippabo.e03ae470.svg";